import { render } from "./SectionButtonsAuction.vue?vue&type=template&id=3ce62867"
import script from "./SectionButtonsAuction.vue?vue&type=script&lang=js"
export * from "./SectionButtonsAuction.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__